import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from "@angular/core";
import { DataService } from "src/app/services/data.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { isPlatformBrowser } from "@angular/common";
import { Title } from "@angular/platform-browser";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "src/app/services/auth.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit {
  profileContent: FormGroup;

  user: any = {};
  photoURL: any = "";
  id: string = "";
  message = "";
  imgUrlLoad: boolean = false;
  @ViewChild("submitBtn") submitBtn: ElementRef<HTMLButtonElement>;
  constructor(
    private _fb: FormBuilder,
    private dataService: DataService,
    private afs: AngularFirestore,
    private storage: AngularFireStorage,
    private _snackBar: MatSnackBar,
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private title: Title
  ) {
    this.user = this.dataService.userDetail;
    this.id = this.user["id"];
    this.title.setTitle(`Profile | Illusbook`);
    if (this.id) {
      this.getSingleService(this.id).then((data) => {
        data.subscribe((singleservice) => {
          //console.log(singleservice);
          if (singleservice["id"]) {
            if (isPlatformBrowser(this.platformId)) {
              sessionStorage.setItem(
                "userData",
                window.btoa(JSON.stringify(singleservice))
              );
            }
          }
          this.profileContent.get("name").setValue(singleservice["name"]);
          this.profileContent.get("uname").setValue(singleservice["uname"]);
          this.profileContent.get("email").setValue(singleservice["email"]);
          this.profileContent.get("web").setValue(singleservice["web"]);
          this.profileContent.get("loc").setValue(singleservice["loc"]);
          this.profileContent.get("job").setValue(singleservice["job"]);
          this.profileContent.get("behance").setValue(singleservice["behance"]);
          this.profileContent.get("dribble").setValue(singleservice["dribble"]);
          this.profileContent
            .get("pinterest")
            .setValue(singleservice["pinterest"]);
          this.profileContent
            .get("linkedin")
            .setValue(singleservice["linkedin"]);
          this.photoURL = singleservice["photoURL"];
        });
      });
    }
  }

  ngOnInit(): void {
    if(!this.user || !this.user.id) {
      this.router.navigate(["/"]);
      return;
    }
    this.profileContent = this._fb.group({
      name: [""],
      uname: [""],
      email: [""],
      web: [""],
      loc: [""],
      job: [""],
      behance: [""],
      dribble: [""],
      pinterest: [""],
      linkedin: [""],
    });
    this.user = this.dataService.userDetail;
    this.profileContent.get("name").setValue(this.user["name"]);
    this.profileContent.get("uname").setValue(this.user["uname"]);
    this.profileContent.get("email").setValue(this.user["email"]);
    this.profileContent.get("web").setValue(this.user["web"]);
    this.profileContent.get("loc").setValue(this.user["loc"]);
    this.profileContent.get("job").setValue(this.user["job"]);
    this.profileContent.get("behance").setValue(this.user["behance"]);
    this.profileContent.get("dribble").setValue(this.user["dribble"]);
    this.profileContent.get("pinterest").setValue(this.user["dribble"]);
    this.profileContent.get("linkedin").setValue(this.user["linkedin"]);
    this.photoURL = this.user.photoURL;
  }

  addData(file) {
    //console.log(file);
    this.pushFileToStorage(file[0]).subscribe(
      (percentage) => {},
      (error) => {
        //console.log(error);
      }
    );
  }

  onImageError(event: any) {
    console.log(event);
    this.imgUrlLoad = true;
    event.target.src = "assets/img/avatar.png";
  }

  pushFileToStorage(fileUpload): Observable<number | undefined> {
    const filePath = `collection/${fileUpload.name}`;
    const storageRef = this.storage.ref(filePath);
    const uploadTask = this.storage.upload(filePath, fileUpload);
    uploadTask
      .snapshotChanges()
      .pipe(
        finalize(() => {
          storageRef.getDownloadURL().subscribe((downloadURL) => {
            //console.log(downloadURL);
            this.photoURL = downloadURL;
          });
        })
      )
      .subscribe();
    return uploadTask.percentageChanges();
  }

  async submitContent(data, valid) {
    //console.log(data);
    // if (valid) {
    if (this.user.id) {
      data["updatedAt"] = new Date().toString();
      data["updatedOn"] = +new Date();
      this.photoURL ? (data["photoURL"] = this.photoURL) : this.user.photoURL;
      const document = this.afs.doc("/userMaster/" + this.user.id);
      document.update(data);
      this.authService.checkSubscriptionStatus(this.user, true);
      // this.router.navigate(["/collections"]);
      this.submitBtn?.nativeElement.blur();
      this._snackBar.open(
        "Profile updated successfully.",
        "Okay",
        {
          duration: 1000,
        }
      );

      // this.message = "Submitted Successfully";
      setTimeout(() => {
        window.location.reload();
      }, 5000);
      return true;
    } else return false;
    // } else return false;
  }

  async getSingleService(id) {
    const get = await this.afs.doc(`userMaster/${id}`);
    const getdata = await get.valueChanges();
    return getdata;
  }

  delPhoto() {
    this.photoURL = "";
  }
}
